var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 3.5,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8541 10.5311H19.25V10.5H12.5V13.5H16.7386C16.1203 15.2464 14.4586 16.5 12.5 16.5C10.0149 16.5 8 14.4851 8 12C8 9.51488 10.0149 7.5 12.5 7.5C13.6471 7.5 14.6908 7.93275 15.4854 8.63963L17.6067 6.51825C16.2673 5.26987 14.4755 4.5 12.5 4.5C8.35813 4.5 5 7.85813 5 12C5 16.1419 8.35813 19.5 12.5 19.5C16.6419 19.5 20 16.1419 20 12C20 11.4971 19.9482 11.0062 19.8541 10.5311Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86475 8.50912L8.32887 10.3162C8.99562 8.6655 10.6104 7.5 12.5 7.5C13.6471 7.5 14.6907 7.93275 15.4854 8.63962L17.6067 6.51825C16.2672 5.26987 14.4755 4.5 12.5 4.5C9.61925 4.5 7.121 6.12637 5.86475 8.50912Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 19.5003C14.4374 19.5003 16.1976 18.7589 17.5285 17.5533L15.2072 15.589C14.4542 16.1594 13.5182 16.5003 12.5001 16.5003C10.5494 16.5003 8.89299 15.2564 8.26899 13.5205L5.82324 15.4049C7.06449 17.8338 9.58524 19.5003 12.5001 19.5003Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8541 10.5311H19.25V10.5H12.5V13.5H16.7386C16.4416 14.3389 15.902 15.0623 15.206 15.5891C15.2064 15.5888 15.2068 15.5887 15.2071 15.5884L17.5284 17.5526C17.3641 17.7019 20 15.75 20 12C20 11.4971 19.9482 11.0063 19.8541 10.5311Z",
    fill: "#1976D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.16aaecab4718577feeeab027b90d1c9d.svg";
export { ForwardRef as ReactComponent };